/**
 * Sound utility: toggles o-header__utility-sound__embed--visible on the embed when
 * .js-sound-toggle is clicked. Designed to run from a Shopify section asset.
 *
 * In your section Liquid, include once:
 *   {{ 'sound-utility.js' | asset_url | script_tag: defer: 'defer' }}
 * Place markup with .js-sound-utility, .js-sound-toggle, .js-sound-embed inside the section.
 */
(function () {
  "use strict";

  var INIT_ATTR = "data-sound-utility-initialized";

  function toggleClass(element, className) {
    if (element.classList.contains(className)) {
      element.classList.remove(className);
    } else {
      element.classList.add(className);
    }
  }

  function onSoundToggleClick(event, embedElement) {
    event.preventDefault();
    toggleClass(embedElement, "o-header__utility-sound__embed--visible");
  }

  function bindOneUtilityBlock(utilityRoot) {
    var toggleButton = utilityRoot.querySelector(".js-sound-toggle");
    var embedElement = utilityRoot.querySelector(".js-sound-embed");

    if (!toggleButton || !embedElement) {
      return;
    }
    if (utilityRoot.getAttribute(INIT_ATTR) === "true") {
      return;
    }

    toggleButton.addEventListener("click", function onClick(event) {
      onSoundToggleClick(event, embedElement);
    });
    utilityRoot.setAttribute(INIT_ATTR, "true");
  }

  /**
   * @param {Document | Element} [root] - Section element from shopify:section:load, or document for full page.
   */
  function initSoundUtility(root) {
    var scope = root && root.nodeType ? root : document;
    var blocks = scope.querySelectorAll(".js-sound-utility");

    if (!blocks.length && scope.classList && scope.classList.contains("js-sound-utility")) {
      bindOneUtilityBlock(scope);
      return;
    }

    for (var i = 0; i < blocks.length; i += 1) {
      bindOneUtilityBlock(blocks[i]);
    }
  }

  function runInitialInit() {
    initSoundUtility(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runInitialInit);
  } else {
    runInitialInit();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target;
    if (section && section.nodeType === Node.ELEMENT_NODE) {
      initSoundUtility(section);
    }
  });
})();
